
import React, { useEffect, useState } from 'react';
import { Card } from '@/components/ui/card';
import { UserRound } from 'lucide-react';
import usernames from '@/data/usernames.json';

interface RecentVotersProps {
  pollTitle: string;
}

export const RecentVoters: React.FC<RecentVotersProps> = ({ pollTitle }) => {
  const [voter, setVoter] = useState<string>("");
  
  // Function to get random username
  const getRandomUsername = () => {
    const randomIndex = Math.floor(Math.random() * usernames.usernames.length);
    return usernames.usernames[randomIndex];
  };
  
  useEffect(() => {
    // Initialize with a random voter
    setVoter(getRandomUsername());
    
    // Set up interval to add a new voter every 1.5 seconds (increased speed)
    const interval = setInterval(() => {
      setVoter(getRandomUsername());
    }, 1500); // Changed from 2500ms to 1500ms for faster refresh
    
    // Clean up interval on component unmount
    return () => clearInterval(interval);
  }, []);
  
  return (
    <Card className="p-4 mb-4 lg:mb-0 bg-white border-[#6EA136] text-[#344F16]">
      <div className="voters-list">
        <div 
          key={`${voter}-${Date.now()}`} 
          className="flex items-center space-x-2 text-sm py-1.5 transition-opacity duration-500"
          style={{ animation: 'fadeInDown 0.5s ease-out' }}
        >
          <div className="bg-[#D9EDC0] rounded-full p-1.5 flex-shrink-0">
            <UserRound className="w-4 h-4 text-[#344F16] dark:text-white" />
          </div>
          <div className="flex-1 truncate">
            <span className="font-medium text-[#344F16]">@{voter}</span>
            <span className="text-[#344F16] dark:text-white"> voted on this poll</span>
          </div>
        </div>
      </div>
      
      {/* Animation CSS */}
      <style>
        {`
          @keyframes fadeInDown {
            from {
              opacity: 0;
              transform: translateY(-10px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
        `}
      </style>
    </Card>
  );
};
